export default __webpack_public_path__ + "static/media/ic-time-clock.3dc0830f.svg";